import { useState, useEffect } from 'react';
import { Singleton } from "../../../core/services/Singleton";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicButton } from "../../theme/Component/BasicButton";
import { BasicTable } from "../../theme/Component/BasicTable";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { Modal } from "../../theme/Component/Modal";
import { BpmService } from "../../../core/services/BpmService";
import { SelectorClaseTramites } from "./Componentes/SelectorClaseTramites";
import { SelectorTramites } from "./Componentes/SelectorTramites";
import { BasicSwitch } from "../../theme/Component/BasicSwitch";
import { SelectorOffice } from "./Componentes/SelectorOffice";
import { ConditionStatement } from './ConditionStatement';
import { ProcedureDocument } from './ProcedureDocument';
import { ListMenu } from '../../theme/Component/ListMenu';
import { ModalGeneric } from '../../../interfaces';
import { SelectFunctionalID } from '../../admin/configuracion/functionalID/SelectFunctionalID';
import { useDashboardStore } from '../../pages/hooks/useDashboardStore';
import { SelectorRol } from './Componentes/SelectorRol';
import { SelectorProcedureType } from './Componentes/SelectorProcedureType';
import { DropDown } from '../../theme/Component/DropDown';
import { PrintJson } from '../../theme/Component/PrintJson';
import { toast } from 'react-toastify';
import useModal, { MODAL_LG, MODAL_md } from '../../theme/Component/hooks/useModal';
import { WorkGroupByIDLn } from '../../admin/configuracion/functionalID/WorkGroupByIDLn';

interface BusinessProcess {
    Name: string
    Description: string
    ActivityType: number
    IDOffice: number
    UseDistributionChannel: boolean,
    ValidateDocuments: boolean,
    LimitByOffice: boolean,
    IDBusinessProcess: number | null,
    IDLnFunctionalID: number,
    ProcedureRow: number,
    IDProcedure?: number,
    FalseIDLnPath?: string,
    TrueIDLnPath?: string,
    FunctionalIDValidateName?: string,
    IDBusinessRole?: number,
}

export const Procedure = () => {

    const single = Singleton.getInstance()
    const { setLoading } = useDashboardStore();
    const service = new BpmService();
    const [lista, setLista] = useState([]);
    const [bean, setBean] = useState<BusinessProcess>({
        Name: '', //
        Description: '', //
        ActivityType: undefined, //
        IDOffice: undefined, //
        UseDistributionChannel: false, //
        ValidateDocuments: false, //
        LimitByOffice: false, //
        IDBusinessProcess: null, //
        IDLnFunctionalID: undefined,  //
        ProcedureRow: 0,
        FalseIDLnPath: '',
        TrueIDLnPath: '',
        FunctionalIDValidateName: "",
        IDBusinessRole: undefined,
    });
    const [idProcess, setIDProcess] = useState(null);
    const [idProcessCopy, setIDProcessCopy] = useState<number>(null);
    const [idModule, setIDModule] = useState(0);
    const [idModuleCopy, setIDModuleCopy] = useState<number>(null);
    const [modal, setModal] = useState<ModalGeneric>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalCopy, setModalCopy] = useState<ModalGeneric>({ name: 'Duplicar Tramite', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalDuplicate, setModalDuplicate] = useState<ModalGeneric>({ name: 'Duplicar Procedimiento', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalConfirm, setModalConfirm] = useState<any>({ name: 'Confirmar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalAF, setModalAF] = useState<any>({ name: 'Agregar Control de Flujo a Procedimientos', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalDR, setModalDR] = useState<any>({ name: 'Documentos Requeridos', tabIndex: -1, view: false, btnClose: true, format: 'modal-lg' });
    const [modalChar, setModalChar] = useState<any>({ name: 'Lista de caracterizaciones', tabIndex: -1, view: false, btnClose: true, btnSubmit: false, format: 'modal-sm' });

    const [charList, setCharList] = useState([]);

    const modalWorkGroup = useModal("Grupo de trabajo", MODAL_LG);

    const idBean = 'IDProcedure';

    const head = [
        { title: 'ID', property: idBean },

        { title: 'Nombre', property: 'Estados1' },
        { title: 'Orden', property: 'ProcedureRow' },
        { title: 'Control de flujo', property: 'ConditionList' },
        { title: 'Actividad', property: 'Estados' },

    ]

    const renderActividad = (item: any) => {
        let render =
            ` 
        <div>            
            <strong>Actividad: </strong><small>${item.DataBeanProperties.ActivityTypeName ? item.DataBeanProperties.ActivityTypeName : 'NA'}</small><br />
            <strong>Rol: </strong><small>${item.DataBeanProperties.BusinessRoleName ? item.DataBeanProperties.BusinessRoleName : 'NA'}</small><br />
            <strong>Grupo: </strong><small>${item.DataBeanProperties.FunctionalIDValidateName ? item.DataBeanProperties.FunctionalIDValidateName : 'NA'}</small><br />
        </div>
        `
        return render;
    }


    const renderNombre = (item: any) => {
        let render1 = ` 
        <div>            
        <strong>Etapa: </strong><small>${item.DataBeanProperties.Name ? item.DataBeanProperties.Name : 'NA'}</small><br />
            <strong>Tipo: </strong><small>${item.DataBeanProperties.ActivityTypeName ? item.DataBeanProperties.ActivityTypeName : 'NA'} - (${item.DataBeanProperties.ProcedureRow ? item.DataBeanProperties.ProcedureRow : 'NA'})</small><br />
        </div>
        `
        return render1;
    }

    useEffect(() => {
        if (idProcess) {
            setBean({
                Name: '', //
                Description: '', //
                ActivityType: undefined, //
                IDOffice: undefined, //
                UseDistributionChannel: false, //
                ValidateDocuments: false, //
                LimitByOffice: false, //
                IDBusinessProcess: null, //
                IDLnFunctionalID: undefined,  //
                ProcedureRow: 0,
                FalseIDLnPath: '',
                TrueIDLnPath: '',
                FunctionalIDValidateName: "",
                IDBusinessRole: undefined,
            })
            getLista();
        }
    }, [idProcess])

    const setRowBean = (bean: any) => {
        //console.log("Row : ", bean);
        setBean(bean);
    }

    const getLista = () => {
        setLoading(true);
        service.getProcedureCatalog(idProcess).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp.DataBeanProperties.ObjectValue) {
                    let ll = resp.DataBeanProperties.ObjectValue;
                    ll.forEach((element: any) => {
                        element.DataBeanProperties.Estados = renderActividad(element);
                        element.DataBeanProperties.Estados1 = renderNombre(element);
                    });
                    setLista(ll);
                }
            }
        );
    }


    const eliminarItem = () => {
        setLoading(true);
        service.deleteProcedure(bean.IDProcedure, null).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp) {
                    getLista();
                }
                single.delete(bean.IDBusinessProcess ?? 0, bean);
            }
        );
        setModalConfirm({ ...modalConfirm, 'view': false });

    }

    const agregar = () => {
        setBean({
            Name: '', //
            Description: '', //
            ActivityType: undefined, //
            IDOffice: undefined, //
            UseDistributionChannel: false, //
            ValidateDocuments: false, //
            LimitByOffice: false, //
            IDBusinessProcess: idProcess, //
            IDLnFunctionalID: undefined,  //
            ProcedureRow: 0,
            TrueIDLnPath: '',
            FalseIDLnPath: '',
        })

        setModal({ ...modal, "view": true });

    }

    const duplicateItem = () => {
        let x = bean;
        x.IDProcedure = null;

        updateItem(x)
    }

    const updateItem = (obj: any) => {
        setLoading(true);
        service.updateProcedure(obj).subscribe(
            (resp: any) => {
                setLoading(false);
                if (resp.DataBeanProperties.ObjectValue) {
                    getLista();
                    if (obj.IDProcedure) {
                        single.update(obj);
                    } else {
                        single.create(obj)
                    }
                }
                setModal({ ...modal, 'view': false });
                setModalDuplicate({ ...modalDuplicate, "view": false })
            });
    }

    const spam = () => {
        setLoading(true);
        service.getBusinessCharacterizationCatalog(idProcess)
            .subscribe((resp: any) => {
                //console.log(resp);
                if (resp.DataBeanProperties.ObjectValue) {
                    setCharList(resp.DataBeanProperties.ObjectValue)
                }
                setLoading(false);

            })
        setModalChar({ ...modalChar, 'view': !(modalChar.view) });
    }

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-line', visible: true, evento: () => { setModal({ ...modal, "view": true }); } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-2-line', visible: true, evento: () => { setModalConfirm({ ...modalConfirm, "view": true }) } },
            { titulo: 'Editar control de flujo', icono: 'ri-file-user-line', visible: true, evento: () => { setModalAF({ ...modalAF, "view": true }) } },
            { titulo: 'Documentos Requeridos', icono: 'ri-file-user-line', visible: true, evento: () => { setModalDR({ ...modalDR, "view": true }) } },
            { titulo: 'Duplicar Procedimiento', icono: 'ri-scissors-line', visible: true, evento: () => { setModalDuplicate({ ...modalDuplicate, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: agregar }
    ]

    const actionsDropDown = [
        { id: 1, name: 'Duplicar Tramite', permiso: null, activo: lista.length > 0 },
    ];

    const eventChange = (e: any) => {
        if (e.id === 1) {
            setIDModuleCopy(null);
            setIDProcessCopy(null);
            setModalCopy({ ...modalCopy, "view": true });
        }
    }

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={eventChange}></DropDown>
                </div>
            </div>
        )
    }

    const handleCopyItems = async () => {
        const errors = [];

        for (const item of lista) {
            if (!item.DataBeanProperties) {
                errors.push(`El objeto con ID desconocido no tiene propiedades válidas.`);
                continue;
            }

            const updatedItem = {
                ...item.DataBeanProperties,
                IDProcedure: null,
                IDBusinessProcess: idProcessCopy,
            };

            try {
                await updateItem(updatedItem);
            } catch (error) {
                errors.push(`Error al actualizar el objeto con orden ${item.DataBeanProperties.ProcedureRow}: ${error.message || "Operación fallida"}`);
            }
        }

        if (errors.length > 0) {
            console.error("Errores durante la copia:", errors);
            alert(`Ocurrieron errores durante el proceso:\n${errors.join("\n")}`);
        } else {
            toast.success("Todos los objetos fueron copiados exitosamente.");
        }
    };



    return (
        <>
            <BasicPage titulo="Procedimientos">
                <div className="row">
                    <div className="col-md-6">
                        <SelectorTramites titulo="Clase de tramites" idSelector={idModule} onChange={(e: any) => { setIDModule(e) }} />
                    </div>
                    {idModule > 0 &&
                        <>
                            <div className="col-md-6">
                                <SelectorClaseTramites idProcess={idModule} idSelector={idProcess} onChange={(e: any) => { setIDProcess(e) }} />
                            </div>
                            <div className="row">
                                <div className="col-md-12 p-2">
                                    {idProcess != null && idProcess != undefined && !isNaN(idProcess) &&
                                        <BasicTable headButtons={buttons()} listButtons={listaBotones()} iconButtons={iconButtonsItem} head={head} body={lista} rowSet={setRowBean}></BasicTable>
                                    }
                                </div>
                            </div>
                        </>
                    }
                </div>
            </BasicPage>

            <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                {bean.Name}
            </ModalConfirm>

            <Modal modal={modal} updateModal={setModal} eventModal={() => { updateItem(bean) }}>
                <div className="row">
                    <div className="col-md-6">
                        <label className="form-label">Orden en el flujo</label>
                        <input type="number" className="form-control" value={bean.ProcedureRow} onChange={(e) => { setBean({ ...bean, 'ProcedureRow': parseInt(e.target.value) }) }} />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Nombre</label>
                        <input type="text" className="form-control" value={bean.Name} onChange={(e) => { setBean({ ...bean, 'Name': e.target.value }) }} />
                    </div>

                    {bean.ActivityType == 8 &&
                        <>
                            <div className="col-md-6">
                                <label className="form-label">Línea Opción Positiva</label>
                                <input type="number" className="form-control" value={bean.TrueIDLnPath} onChange={(e) => { setBean({ ...bean, 'TrueIDLnPath': e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Línea Opción Negativa</label>
                                <input type="number" className="form-control" value={bean.FalseIDLnPath} onChange={(e) => { setBean({ ...bean, 'FalseIDLnPath': e.target.value }) }} />
                            </div>
                        </>
                    }

                    <div className="col-md-12">
                        <label className="form-label">Descripción</label>
                        <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, 'Description': e.target.value }) }}></textarea>
                    </div>

                    <div className="col-md-6">
                        <label className='form-label'>Tipo de actividad:</label>
                        <SelectorProcedureType idSelector={bean.ActivityType} onChange={(e) => { setBean({ ...bean, "ActivityType": e }) }}></SelectorProcedureType>
                    </div>

                    <div className="col-md-6">
                        <SelectorOffice idSelector={bean.IDOffice} titulo="Seleccione una sucursal" onChange={(e: any) => { setBean({ ...bean, "IDOffice": e }) }}></SelectorOffice>
                    </div>

                    <div className="col-md-6">
                        <SelectFunctionalID functionalIDLn={bean.IDLnFunctionalID} onChange={(e: any) => setBean({ ...bean, 'IDLnFunctionalID': e?.IDLn })} />
                    </div>

                    {bean.IDLnFunctionalID > 0 &&
                        <div className="col-6">
                            <SelectorRol idLnFunctionalID={bean.IDLnFunctionalID} idSelector={bean.IDBusinessRole} onChange={(e) => { setBean({ ...bean, "IDBusinessRole": e }) }} titulo='Rol' ></SelectorRol>
                        </div>
                    }

                    <div className="row">
                        <div className="col-md-4">
                            <div className="form-group mt-4">
                                ¿Usa canal de distribuición?
                                <BasicSwitch label="" estado={bean.UseDistributionChannel} eventChange={(e: any) => { setBean({ ...bean, "UseDistributionChannel": e }) }}></BasicSwitch>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group mt-4">
                                ¿Validar documentos?
                                <BasicSwitch label="" estado={bean.ValidateDocuments} eventChange={(e: any) => { setBean({ ...bean, "ValidateDocuments": e }) }}></BasicSwitch>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="form-group mt-4">
                                ¿Limitar procedimiento a oficina de radicación?
                                <BasicSwitch label="" estado={bean.LimitByOffice} eventChange={(e: any) => { setBean({ ...bean, "LimitByOffice": e }) }}></BasicSwitch>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-md-9 mt-4">

                            <BasicButton value="Caracterizaciones" icon="ri-user-settings-line" eventClick={spam} ></BasicButton>
                            <BasicButton disable={!bean.IDLnFunctionalID} value="Grupo Trabajo" icon="ri-group-line" eventClick={() => { modalWorkGroup.open() }} ></BasicButton>
                        </div>

                    </div>
                </div>
            </Modal>


            <Modal modal={modalWorkGroup.modal} updateModal={modalWorkGroup.setModal}>
                <WorkGroupByIDLn IDLn={bean.IDLnFunctionalID} />
            </Modal>
            <Modal modal={modalAF} updateModal={setModalAF}>
                <ConditionStatement _idBussinesProcces={idProcess} refresh={getLista} _idProcedure={bean.IDProcedure}></ConditionStatement>
            </Modal>

            <Modal modal={modalDR} updateModal={setModalDR} >
                <ProcedureDocument idProcedure={bean.IDProcedure}></ProcedureDocument>
            </Modal>

            <Modal modal={modalDuplicate} updateModal={setModalDuplicate} eventModal={duplicateItem} onSubmitLabel='Confirmar' >
                <div className="row">
                    <div className="col-md-12">
                        <label className="form-label">Orden en el flujo</label>
                        <input type="number" className="form-control" value={bean.ProcedureRow} onChange={(e) => { setBean({ ...bean, 'ProcedureRow': parseInt(e.target.value) }) }} />
                    </div>
                </div>
            </Modal>

            <Modal
                modal={modalCopy}
                updateModal={setModalCopy}
                eventModal={
                    () => {
                        if (idProcessCopy) {
                            if (idProcessCopy === idProcess) {
                                toast.error("No se puede seleccionar el mismo Tramite")
                            } else {
                                handleCopyItems()
                            }
                        } else {
                            toast.error("Tramite no valido")
                        }
                    }
                } onSubmitLabel='Confirmar' >
                <div className="row">
                    <p>¿Estás seguro de que deseas copiar los procedimientos al proceso seleccionado?</p>
                    <div className="col-md-12">
                        <SelectorTramites titulo="Clase de tramite" idSelector={idModuleCopy} onChange={(e: any) => { setIDModuleCopy(e) }} />
                    </div>
                    <div className="col-md-12">
                        <SelectorClaseTramites idProcess={idModuleCopy ? idModuleCopy : idModule} idSelector={idProcessCopy} onChange={(e: any) => { setIDProcessCopy(e) }} />
                    </div>
                    <PrintJson json={idProcessCopy} />
                </div>
            </Modal>

            <Modal modal={modalChar} updateModal={setModalChar}>
                <ul>
                    {
                        charList.length > 0 ? charList.map((i: any) => <li>{i.DataBeanProperties.CustomerTypeName}</li>)
                            : <h3 className='m-3'>No se encuentran caracterizaciones vinculadas al trámite </h3>
                    }
                </ul>
            </Modal>
        </>
    )
}